import React from 'react';
import { Container } from './styles';

/**
 * @typedef {Object} FlexProps
 * @property {boolean} column
 * @property {number} gap
 * @property {import('react').CSSProperties['justifyContent']} justifyContent
 * @property {import('react').CSSProperties['alignItems']} alignItems
 */

/**
 * @param {React.HTMLProps<HTMLDivElement> & FlexProps} props
 * @returns {JSX.Element}
 */
export function Flex({
  children,
  column = false,
  gap = 8,
  justifyContent,
  alignItems,
  ...props
}) {
  return (
    <Container
      {...props}
      column={column}
      gap={gap}
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      {children}
    </Container>
  );
}
